import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCREASChartsDataContext } from './hooks/useIDCREASChartsDataContext';

export const ServicesEvolutionChart = () => {
    const { chartData } = useIDCREASChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual de Serviços"
            subtitles={chartData.services.map((item) => getYearLabel(item.ano))}
            values={chartData.services.map(
                (item) => Number(item.servicos) || 0
            )}
        />
    );
};
